import React from "react";
import { View, StyleSheet } from "react-native";
import { GoLiveProvider, useGoLive } from "./GoLiveContext";
import { StreamStatusProvider } from "../../../../context/StreamStatusContext";
import { ScreenBGGradientView } from "../../../../common/CommonView";
import Header from "../Common/Header";
import { Step1StreamForm } from "./components/Step1StreamForm";
import Step2Dashboard from "./components/Step2Dashboard";
import { useNavigation } from "@react-navigation/native";
import { AppScreens } from "../../../Utility/AppScreens";
import { navigateToScreen } from "../../../../utility/NavigationHelper";

const GoLiveContent = () => {
  const { step } = useGoLive();
  const navigation = useNavigation();

  return (
    <View style={styles.container}>
      <ScreenBGGradientView />
      <Header
        btnSearchTapped={() =>
          navigateToScreen(navigation, AppScreens.SearchEventWebScreen)
        }
        btnWalletTapped={() => {}}
        btnStartTutorialTapped={() => {}}
        btnMessageTapped={() => {}}
        btnNotificationTapped={() => {}}
        btnProfileTapped={() =>
          navigateToScreen(navigation, AppScreens.MyProfileWebScreen)
        }
      />
      <View style={styles.content}>
        {step === 1 ? <Step1StreamForm /> : <Step2Dashboard />}
      </View>
    </View>
  );
};

const GoLivePage = () => {
  return (
    <StreamStatusProvider>
      <GoLiveProvider>
        <GoLiveContent />
      </GoLiveProvider>
    </StreamStatusProvider>
  );
};

export default GoLivePage;

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    flex: 1,
  },
});
